import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, ShieldCheck, ShieldX } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ST = { draft: "صادر", sent: "مُرسل للموظف", signed: "موقّع من الموظف" };

export default function VerifyLetter() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { axios.get(`${API}/public/verify-letter/${id}`).then((r) => setD(r.data)).catch((e) => setErr(e.response?.data?.detail || "تعذّر التحقق")); }, [id]);
  const Row = ({ k, v }) => <div className="flex justify-between gap-4 border-b border-slate-100 py-2.5 text-sm"><span className="text-slate-500">{k}</span><b className="text-left text-slate-800">{v || "—"}</b></div>;
  return (
    <div dir="rtl" className="grid min-h-screen place-items-center bg-slate-100 p-4 font-body">
      <div className="w-full max-w-md rounded-3xl bg-white p-7 shadow-xl" data-testid="verify-letter">
        {!d && !err && <Loader2 className="mx-auto h-6 w-6 animate-spin text-slate-400" />}
        {err && <div className="text-center" data-testid="verify-letter-invalid"><ShieldX className="mx-auto h-14 w-14 text-rose-500" /><h1 className="mt-3 font-heading text-xl font-extrabold text-rose-700">مستند غير موثّق</h1><p className="mt-2 text-sm text-slate-500">{err}</p></div>}
        {d && <>
          <div className="text-center"><ShieldCheck className="mx-auto h-14 w-14 text-emerald-500" />
            <h1 className="mt-3 font-heading text-xl font-extrabold text-emerald-700" data-testid="verify-letter-ok">مستند موثّق وصادر رسمياً</h1>
            <p className="mt-1 text-sm text-slate-500">{d.company}{d.cr_number ? ` · س.ت ${d.cr_number}` : ""}</p></div>
          <div className="mt-5">
            <Row k="رقم المستند" v={d.number} /><Row k="النوع" v={d.type} /><Row k="العنوان" v={d.title} />
            <Row k="الموظف" v={d.employee_name} /><Row k="التاريخ" v={d.date} /><Row k="الحالة" v={ST[d.status] || d.status} />
          </div>
          <p className="mt-4 text-center text-[11px] text-slate-400">تحقّق أن البيانات أعلاه مطابقة للمستند الذي بين يديك — WorkZone</p>
        </>}
      </div>
    </div>
  );
}
